import { HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

import { Location } from '@angular/common';
import { HttpHandler, HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class BrandInterceptor implements HttpInterceptor {
    /**
     * List of application paths where this interceptor should not operate.
     * Note: Allow us to go in the configurator page, otherwise we would not be able to correct wrong data.
     * As the application loads the configuration when being created and for example a 404 can be returned.
     * @private
     */
    private readonly excludedPaths = [];
    /**
     * List of api endpoints where this interceptor should not operate
     * @private
     */
    private readonly excludedUrls = [];
    /**
     * List of api endpoints where this interceptor should operate even if outside the apiUrl.
     * This is useful for endpoints that are not part of the main API but still need the brand code.
     * For example, the coupons APIs
     * @private
     */
    private readonly includedUrls = ['api/coupons/offers'];

    constructor(private location: Location) {}

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<any> {
        const isExcludedEndpoint = this.excludedUrls.some((url) => req.url.includes(url));
        const isExcludedPath = this.excludedPaths.includes(this.location.path());
        const isIncludedEndpoint = this.includedUrls.some((url) => req.url.includes(url));

        if (!isExcludedPath && !isExcludedEndpoint && (req.url.includes(environment.apiUrl) || isIncludedEndpoint)) {
            const clonedRequest = req.clone({
                setHeaders: {
                    'brand-code': environment.brandCode.toString(),
                },
            });
            return next.handle(clonedRequest);
        }
        return next.handle(req);
    }
}

// export const brandInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
//     if (req.url.includes(environment.apiUrl)) {
//         const clonedRequest = req.clone({
//             setHeaders: {
//                 'brand-id': environment.brandId.toString(),
//             },
//         });
//         return next(clonedRequest);
//     }
//     return next(req);
// };
